module.exports = __webpack_public_path__ + "media/src/assets/images/professional-service-4f0fc282e0ded965a59042ea1a6af5b3.svg";